const BASE_URL = {
  kotakSdk: {
    url: "https://kotak-sdk.verismart.co.in/kotak/",
    version: "",
  },
};

export default BASE_URL;
